import type { ComponentProps } from 'react';

import type { HomePageCard } from '@zillow/zrs-cms-messaging';

import buyDefault from '../../../public/rtbImages/Buy_a_home.png';
import buyOptimized from '../../../public/rtbImages/Buy_a_home.webp';
import buyDefaultVr from '../../../public/rtbImages/Buy_a_home_VR.png';
import buyOptimizedVr from '../../../public/rtbImages/Buy_a_home_VR.webp';
import rentDefault from '../../../public/rtbImages/Rent_a_home.png';
import rentOptimized from '../../../public/rtbImages/Rent_a_home.webp';
import rentDefaultVr from '../../../public/rtbImages/Rent_a_home_VR.png';
import rentOptimizedVr from '../../../public/rtbImages/Rent_a_home_VR.webp';
import sellDefault from '../../../public/rtbImages/Sell_a_home.png';
import sellOptimized from '../../../public/rtbImages/Sell_a_home.webp';
import sellDefaultVr from '../../../public/rtbImages/Sell_a_home_VR.png';
import sellOptimizedVr from '../../../public/rtbImages/Sell_a_home_VR.webp';
import { AllHopsPlacements } from '../../types/genericTypes';

export type RTBCardConfig = { placementName: AllHopsPlacements; link: string } & Pick<
    ComponentProps<typeof HomePageCard>,
    'headline' | 'description' | 'buttonText' | 'defaultImageMedia' | 'optimizedImageMedia'
>;

export const getRTBCards = (isVisualRefreshEnabled: boolean): RTBCardConfig[] => {
    const imgSrc = isVisualRefreshEnabled
        ? {
              buy: {
                  default: buyDefaultVr,
                  optimized: buyOptimizedVr,
              },
              rent: {
                  default: rentDefaultVr,
                  optimized: rentOptimizedVr,
              },
              sell: {
                  default: sellDefaultVr,
                  optimized: sellOptimizedVr,
              },
          }
        : {
              buy: {
                  default: buyDefault,
                  optimized: buyOptimized,
              },
              rent: {
                  default: rentDefault,
                  optimized: rentOptimized,
              },
              sell: {
                  default: sellDefault,
                  optimized: sellOptimized,
              },
          };

    return [
        {
            placementName: AllHopsPlacements.HOME_PAGE_RTB_CARD_1,
            link: '/homes/',
            headline: 'Buy a home',
            description:
                'Find your place with an immersive photo experience and the most listings, including things you won’t find anywhere else.',
            buttonText: 'Search homes',
            defaultImageMedia: {
                src: imgSrc.buy.default,
                type: 'image/png',
            },
            optimizedImageMedia: {
                src: imgSrc.buy.optimized,
                type: 'image/webp',
            },
        },
        {
            placementName: AllHopsPlacements.HOME_PAGE_RTB_CARD_2,
            link: '/sell/',
            headline: 'Sell a home',
            description:
                'No matter what path you take to sell your home, we can help you navigate a successful sale.',
            buttonText: 'See your options',
            defaultImageMedia: {
                src: imgSrc.sell.default,
                type: 'image/png',
            },
            optimizedImageMedia: {
                src: imgSrc.sell.optimized,
                type: 'image/webp',
            },
        },
        {
            placementName: AllHopsPlacements.HOME_PAGE_RTB_CARD_3,
            link: '/homes/for_rent/',
            headline: 'Rent a home',
            description:
                'We’re creating a seamless online experience – from shopping on the largest rental network, to applying, to paying rent.',
            buttonText: 'Find rentals',
            defaultImageMedia: {
                src: imgSrc.rent.default,
                type: 'image/png',
            },
            optimizedImageMedia: {
                src: imgSrc.rent.optimized,
                type: 'image/webp',
            },
        },
    ];
};
